import React, {useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { toast } from "../../store/features/slice-alerts";
import Button from "../Button";

import G from "../../app/globals";




const SingleRefer = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [eRefOpen, seteRefOpen] = useState(false);
    const centresListBasic = useSelector((state) => state.centres.basic);

    const copyRefInfo = (id) => {
        G.COPY_STRING_TO_CLIPBOARD(id);
        dispatch(toast(
            {
              message: 'ID has been copied to the clipboard',
              type: 'success',
              timeout: 5000
            }
        ))
    }

    return (
        <div className="page-doctor-single--refer">
            <Button 
                className="btn-primary text-yellow full-width"
                text="Secure online referral"
                Clicked={() => history.push(`/refer-patient/doctor/${props.slug}/proceed`)}
            />
            {props.referralInfo && props.referralInfo.length > 0 ? 
                <Button 
                    className="btn-primary full-width"
                    text="Practice eReferral Software"
                    Clicked={() => seteRefOpen(true)}
                />
            : null }
                                
            {eRefOpen && props.referralInfo && props.referralInfo.length > 0 ? 
                props.referralInfo.map((item, index) => (
                    <div key={index} className="page-doctor-single--medical-object">
                        <h2>{item.platform} ID: {item.number}</h2>
                        {centresListBasic ? <p>{centresListBasic[item.centre].title}</p> : null}
                        <Button
                            className="btn-primary text-yellow full-width"
                            text="Copy"
                            Clicked={() => copyRefInfo(item.number)}
                        />
                    </div>
                ))
            : null}
        </div> 
    );
};

export default SingleRefer;